import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import React from 'react';

function BodyItem(props) {
  console.log('data.myVirtualMoney', props.val);
  return (
    <div>
      <div key={props.key} className="my-accounts-promotional-item">
        <span
          className={(props.val.type != 'credit' ? 'secondary-text' : 'primary-text') + '  font12'}
        >
          {props.val.amount}
        </span>
        <div
          className={props.val.type == 'credit' ? 'secondary-up-triangle' : 'primary-down-triangle'}
        ></div>

        <div>
          <div className="font9">
            {CommonService.capitalize(props.val.category_info && props.val.category_info.label)}
          </div>
          <div className="font9 light-grey-text">
            {DateService.changeDateFormat(props.val.created_date, 'yyyy-mm-dd', 'dd/mm/yyyy')}
          </div>
        </div>

        <div>
          <div className="font9">
            {props.val.expire_info.expired ? props.t('PROFILE.EXPIRED_ON') : 'Vencido el'}
          </div>
          <div className="font9">
            {DateService.changeDateFormat(
              props.val.expire_info.expires_at,
              'yyyy-mm-dd',
              'dd/mm/yyyy',
            )}
          </div>
        </div>
      </div>

      <hr className="horizontal-line" />
    </div>
  );
}

export default BodyItem;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyPromotions/components/BodyItem.js